module.exports = __webpack_public_path__ + "static/media/skyArt.3101bbb0.jpg";